import { UrlSegment, UrlMatchResult } from '@angular/router';

export function yearMatcher(segments: UrlSegment[]): UrlMatchResult | null {
  const yearRegex = /^\d{4}$/;

  if (segments.length === 1 && yearRegex.test(segments[0].path)) {
    return {
      consumed: segments,
      posParams: {
        year: segments[0],
      },
    };
  }

  return null;
}
